// @flow

import { gql, graphql } from 'react-apollo';

import Footer from '~/components/layout/Footer';

const entries = [
    { label: 'Home', link: '/' },
    { label: 'Reviews', link: '/reviews' },
    {
        label: 'Forum',
        link: 'https://forum.supagemu.com',
        externLink: true,
    },
    { label: 'Staff', link: '/staff' },
];

const platforms = [
    { label: 'Super Famicom', link: '/platforms/super-famicom' },
    { label: 'Famicom', link: '/platforms/famicom' },
    { label: 'PC Engine', link: '/platforms/pc-engine' },
    { label: 'Mega Drive', link: '/platforms/mega-drive' },
];

export default graphql(
    gql`
    query {
        contributors: users {
            id,
            name,
            slug,
            avatar {
                secure_url
            }
        }
    }`,
    {
        props: ({ data: { contributors }, ownProps }) => ({
            ...ownProps,
            entries,
            platforms,
            contributors,
        }),
    }
)(Footer);



// WEBPACK FOOTER //
// ./src/components/layout/FooterContainer.js